import React from "react";
import { Dialog, Box } from "@mui/material";
import OrderSuccessCard from "../Cards/OrderSuccesscard";

interface OrderSegment {
  orderId: string;
  status: string;
  provider: string;
  fiatCurrency: string;
  quantity: number;
  amount: number;
  platformFee?: number;
  loanAmount?: number;
}

interface TradeSummary {
  totalQuantity: number;
  totalAmount: number;
  totalPlatformFee: number;
  totalLoanAmount: number;
}

interface OrderDetails {
  symbol?: string;
  stockName?: string;
  side: 'Buy' | 'Sell';
  isSplit: boolean;
  orders: OrderSegment[];
  summary: TradeSummary;
  partialFailure?: boolean;
  failedSegments?: { provider: string; quantity: number; error: string }[];
  dateTime: string;
}

interface OrderSuccessPopupProps {
  open: boolean;
  onClose: () => void;
  orderDetails: OrderDetails;
  onboardingType?: string;
}

const OrderSuccessPopup: React.FC<OrderSuccessPopupProps> = ({ open, onClose, orderDetails, onboardingType }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
          maxHeight: "90vh",
          overflow: "hidden",
        },
      }}
    >
      <Box sx={{ p: 0 }}>
        <OrderSuccessCard
          orderDetails={orderDetails}
          onClose={onClose}
          onboardingType={onboardingType}
        />
      </Box>
    </Dialog>
  );
};

export default OrderSuccessPopup;
